import { useNavigation, useOutlet } from "@remix-run/react";

import { Spinner } from "../spinner/Spinner";

/**
 * Abstraction on Remix `<Outlet />` that adds a loading
 * indicator when the tab content is being loaded.
 * NOTE: Must be used with a Remix app.
 */
export function TabOutlet() {
  const { location } = useNavigation();
  const outlet = useOutlet();

  const isBusy = (location?.state as { isTab: boolean })?.isTab;

  return (
    <div className="TabOutlet" aria-busy={isBusy}>
      {outlet}

      {isBusy && (
        <div className="TabOutlet-overlay">
          <Spinner size="lg" />
        </div>
      )}
    </div>
  );
}
